/**
 * Bike Parts Page
 * ================
 * Parts inventory for a specific motorcycle.
 */

import { useParams } from 'react-router-dom'
import { useMotorcycle } from '@/hooks/useMotorcycles'
import BikePageHeader from './BikePageHeader'
import { Package } from 'lucide-react'

export default function BikeParts() {
  const { bikeId } = useParams<{ bikeId: string }>()
  const { data: bike, isLoading, error } = useMotorcycle(bikeId || '')

  if (error) {
    return (
      <div className="text-center py-12">
        <p className="text-red-600">Failed to load motorcycle</p>
      </div>
    )
  }

  return (
    <div>
      <BikePageHeader bike={bike} isLoading={isLoading} />

      {/* Placeholder content */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-8">
        <div className="text-center py-12">
          <Package size={48} className="mx-auto text-gray-300 dark:text-gray-600 mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
            Parts on Stock
          </h2>
          <p className="text-gray-500 dark:text-gray-400 max-w-md mx-auto">
            Inventory of parts associated with {bike?.name || 'this motorcycle'} will be displayed here.
            Link existing products from the main inventory to this bike.
          </p>
        </div>
      </div>
    </div>
  )
}
